export default __webpack_public_path__ + "static/cb-eb536553cb92104e2e482893ca543e1b.svg";